import AdaptiveImage from '@Hotels-at-Home/hah-fe-core/dist/components/AdaptiveImage';
import { IBaseProduct } from '@Hotels-at-Home/hah-fe-core/dist/types';
import { ReactElement } from 'react';
import Services from '~/ui/components/common/Services';
import { productServicesMock } from '~/ui/components/common/Services/servicesMock';

interface IProps {
  product: IBaseProduct;
}

const ProductExtraContent = ({ product }: IProps): ReactElement => {
  const extraImage = product.extra_image[0];
  const imageSrc = extraImage?.url_webp ?? extraImage?.url ?? '/images/product-placeholder.jpg';
  return (
    <div>
      <div className="extended-content">
        <AdaptiveImage src={imageSrc} alt={product.image.label} />
      </div>
      <Services items={productServicesMock} />
    </div>
  );
};

export default ProductExtraContent;
